


















































import Vue from 'vue'

export default Vue.extend({
  name: 'core-bonus-page',
  props: {
    pilot: {
      type: Object,
      required: true,
    },
    cbEligible: {
      type: Boolean,
    },
  },
})
